import { useState,useEffect } from 'react';
import {
    useStripe,useElements, //inject with these hooks
    PaymentElement,
} from '@stripe/react-stripe-js';
import {
    Form, FormGroup,
    Container, // even if the row is <FormGroup row>, you need this
    Row,
    Col,
    Label, Input,
    Button,
    Alert
} from 'reactstrap';

const createOptions = (fontSize, padding) => {
    return {
        style: {
            base: {
                color: '#424770'
            },
            invalid: {
                color: '#9e2146',
            },
        },
    };
};
const centsToDollars = (cents) => {
    //returns a string for the number of dollars
    var dollars = (cents / 100).toFixed(2)
    if (dollars.endsWith('00')) {
        dollars = (cents / 100).toFixed()
    }
    return dollars
}
const getLicenseNames = (base_name, nb_licenses) => {
    //gives a list of license names for display
    if (base_name === '') {
        return ''
    }
    if (nb_licenses > 1) {
        var ln_str = "["
        for (var i = 0; i < nb_licenses; i++) {
            var suffix = '00' + (i + 1)
            ln_str += base_name + "-" + suffix.slice(-2) + ','
        }
        return ln_str.slice(0, -1) + "]"
    }
    return '"' + base_name + '"' //only one license
}


///The Payment form for the serverless, PaymentIntents API "buy" page.
export function PaymentElementForm() {
    // Get a reference to Stripe or Elements using hooks.
    const stripe = useStripe();
    const elements = useElements();

    const fontSize = 18.0; //should this be a prop?

    // four phases for 'purchasePhase':
    //    '', the default, when user is filling out form
    //    'pending', after hitting 'charge' button, but before 'charge' page returns
    //    'success', if charge returns good,
    //    'failure', if charge returns bad
    const unit_price = 4500;

    const [state,setState] = useState({
        customerName: '',
        licenseName: '',
        email: '',
        nbLicenses: 1,
        cardInfoReady: false,
        totalPriceString: centsToDollars(unit_price),
        licenseNames: '',
        purchasePhase: '',
        successMessage: 'Thank You! License information will be in your inbox.',
        failureMessage: 'Oh No! Something has gone wrong with the purchase.'
    });

    useEffect(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const redirect_status = urlParams.get('redirect_status');
        // const order_id = urlParams.get('order_id');
        console.log("on loading, the redirect status is: ");
        if (redirect_status === "succeeded") { 
            handleChargeSuccess({
                "purchase_status": "success",
                "message": state.successMessage,
            });
        }else{
            //redirect_status should be 'undefined' always, on load, so I believe.
            // and therefore the purchase_status should be on the default of ""
        }
     },[]); //that last bracket should keep the useEffect from endlessly looping through renders

    const handleCustomerNameChange = (e) => {
        setState({ ...state,customerName: e.target.value })
    }
    const handleLicenseNameChange = (e) => {
        if (e.target.value !== '') {
            setState({...state,
                licenseName: e.target.value,
                licenseNames: getLicenseNames(e.target.value, state.nbLicenses)
            })
        } else {
            setState({ ...state,licenseName: e.target.value })
        }
    }
    const handleCardChange = (card_info) => {
        setState({
            ...state,
            cardInfoReady: card_info.complete
        })
    }
    const handleEmailChange = (e) => {
        setState({ ...state,email: e.target.value })
    }
    const handleNbLicensesChange = (e) => {
        var nb_licenses = e.target.value;
        if (nb_licenses < 1) {
            nb_licenses = 1;
        }
        if (nb_licenses > 99) {
            nb_licenses = 99;
        }
        setState({
            ...state,
            nbLicenses: nb_licenses,
            totalPriceString: centsToDollars(nb_licenses * unit_price),
            licenseNames: getLicenseNames(state.licenseName, nb_licenses)
        });
    }
    
    // handles a successful response from the create-payment-intent server call,
    //  but it needs to happen WHEN THE PAGE FIRST LOADS
    const handleChargeSuccess = (resp) => {
        if (resp.purchase_status === 'success') {
            setState({  
                ...state,
                purchasePhase: 'success',
                successMessage: resp.message
            });
        }else{
            console.log('handleChargeSuccess has resp.purchase_status of: '+ resp.purchase_status);
            console.log(resp)
            // handleChargeFailure(resp);
        }
    }
    
    const handleElementsSubmitFailure = (error) => {
        var failmess = "Stripe had an error prior to submitting.";
        if (error.message) {
            failmess = error.message;
        }
        setState({ 
            ...state,
            purchasePhase: 'failure',
            failureMessage: "Oh no! The purchase didn't go through. "+failmess
        });
    }

    const handleChargeFailure = (error) => {
        var failmess = "Our servers reported an unknown Failure.";
        switch (error.type) {
            case "api_error":
                failmess = "An unusual error with the Stripe system has occurred.";
                break;
            case "card_error":
                // probably stuff like "card was declined"
                failmess = error.message;
                break;
            case "invalid_request_error":
                failmess = "Stripe is reporting an invalid request to its system.";
                break;
            case "idempotency_error": //rare
                failmess = "A charge might have been attempted too many times.";
                break;
            default:
                console.log("HandleChargeFailure has this unexpected error type:" + error.type)
                break;
        }
        setState({ 
            ...state,
            purchasePhase: 'failure',
            failureMessage: "Oh no! The purchase didn't go through. "+failmess
        });
    }

    const handleSubmit = async (ev) => {
        const page_url_base = process.env.REACT_APP_PAGE_URL_BASE;
        const api_url = process.env.REACT_APP_API_URL_BASE + "/create-payment-intent";
        // const apiKey = process.env.REACT_APP_STRIPE_API_KEY;
        //if (process.env.NODE_ENV !== 'production') { //also the mode for build:s3dev
        // if (apiKey.startsWith("pk_test")) {
        //     console.log("you are going to call the test server");
        //     // api_url = "http://localhost:9000/lambda-url/mfc-api-create-pi";
        //     // api_url = "https://2xtvm8k4z2.execute-api.us-west-1.amazonaws.com/dev/create-payment-intent";
        //     api_url = "https://dev-srv.mfchangenote.com/create-payment-intent"; 
        // }
        
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        ev.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js hasn't yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        setState({ 
            ...state,
            purchasePhase: 'pending'
        });

        // Trigger form validation and wallet collection
        const {error: submitError} = await elements.submit();
        if (submitError) {
            handleElementsSubmitFailure(submitError);
            return;
        }

        // Create the PaymentIntent and obtain clientSecret
        const res = await fetch(api_url, {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            referrer: "no-referrer",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
                'customer_name': state.customerName,
                'customer_email': state.email,
                'product': 'mfC4',
                'license_name': state.licenseName,
                'nb_of_licenses': state.nbLicenses
            }),
        });
        
        const {client_secret: clientSecret, 
            error: piCreationErrorMessage,
            // order_id: order_id, //for future use, maybe TODO
        } = await res.json();
        if (piCreationErrorMessage !== undefined ) {
            console.log("payment intent creation returned this error message: " + piCreationErrorMessage);
            handleElementsSubmitFailure();
            return;
        }

        // Do we need to check the pi for more info? like success or decline? TODO


        // Confirm the PaymentIntent using the details collected by the Payment Element
        const {error} = await stripe.confirmPayment({
            elements,
            clientSecret,
            confirmParams: {
                return_url: page_url_base + '/buy', //the payment_intent id is already in the query parameters.
                // return_url: page_url_base + '/buy?order_id=' + order_id,
                // return_url: 'https://dev-www.mfchangenote.com/order/{order_id}/complete',
            },
        });
        
        if (error) {
            // This point is only reached if there's an immediate error when
            // confirming the payment. Show the error to your customer (for example, payment details incomplete)
            handleChargeFailure(error);
        } else {
            // Your customer is redirected to your `return_url`. For some payment
            // methods like iDEAL, your customer is redirected to an intermediate
            // site first to authorize the payment, then redirected to the `return_url`.
            //
            // Therefore, the "handleChargeSuccess" should be called on page load
        }
    }; //handleSubmit 

    const getAlertMessage = () => {
        switch (state.purchasePhase) {
            case 'pending':
                return <Row><Col md={{ size: 10, offset: 1 }}><Alert color='primary' toggle={onDismissPaymentAlert}>Please wait while your Credit Card is processed.</Alert></Col></Row>;
            case 'success':
                return <Row><Col md={{ size: 10, offset: 1 }}><Alert color='success' toggle={onDismissPaymentAlert}>{state.successMessage}</Alert></Col></Row>;
            case 'failure':
                return <Row><Col md={{ size: 10, offset: 1 }}><Alert color='danger' toggle={onDismissPaymentAlert}>{state.failureMessage}</Alert></Col></Row>;
            default:
                return (<div></div>);
        }
    }
    const onDismissPaymentAlert = () => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const redirect_status = urlParams.get('redirect_status');
        if (redirect_status === "succeeded") {
             window.location = "buy"; 
             return; //unreachable?
        }
        setState({...state,
            // customerName: '',
            // licenseName: '',
            // email: '',
            // nbLicenses: 1,
            cardInfoReady: false,
            // totalPriceString: centsToDollars(unit_price),
            // licenseNames: '',
            purchasePhase:''});
        let pe = elements.getElement('payment');
        if (pe) { pe.clear(); }
    }

    return (
        <Container>
            <Form onSubmit={handleSubmit} id="mfc-payment-form">
                <FormGroup row>
                    <Label for="custname" md={{ size: 2, offset: 1 }}>Customer Name</Label>
                    <Col md='3'>
                        <Input id="custname" type="text" name="customer_name" placeholder="User's name…" required
                            onChange={handleCustomerNameChange} />
                    </Col>
                    <Col md='3' style={{ textAlign: 'left' }}> Your name for my records.
                    <div className='hidden-text'>hidden text</div>
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="licensename" md={{ size: 2, offset: 1 }}>License Name</Label>
                    <Col md='3'>
                        <Input id="licensename" type="text" name="license_name" placeholder="License name…" required
                            onChange={handleLicenseNameChange} />
                    </Col>
                    <Col md='3' style={{ textAlign: 'left' }}>Choose a short name to identify the license <em>(e.g.,'EditRoom1')</em>.</Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="emailaddress" md={{ size: 2, offset: 1 }}>Valid Email Address</Label>
                    <Col md={{ size: 3 }}>
                        <Input id="emailaddress" type="email" name="email_address" placeholder="email address…" required
                            onChange={handleEmailChange} />
                    </Col>
                    <Col md='5' style={{ textAlign: 'left' }}>Your license key will be delivered to this address.
                <br /> It will NOT be used for spam and will never be given or sold to anyone.</Col>
                </FormGroup>
                <FormGroup row>
                    <Label md={{ size: 2, offset: 1 }}>Number of Licenses</Label>
                    <Col md='1'>
                        <Input id="nblicenses" type='number' value={state.nbLicenses} onChange={handleNbLicensesChange} />
                    </Col>
                    <Col style={{ textAlign: 'left' }}>{state.licenseNames}</Col>
                </FormGroup>

                {/* {getPaymentLine()} */}
                <FormGroup row>
                    <Label for='cardelement' md={{ size: 2, offset: 1 }}>Card Details</Label>
                    <Col md='3' style={{ position: 'relative', top: '-10px' }}>
                        <PaymentElement id='cardelement'
                            onChange={handleCardChange}
                            options={createOptions(fontSize)}
                        />
                    </Col>
                    <Col md='2'>
                        <Button color='primary' disabled={!state.cardInfoReady} hidden={state.purchasePhase === "pending"}>
                            Pay &#36;{state.totalPriceString} </Button>
                    </Col>
                </FormGroup>
                {getAlertMessage()}
            </Form>
        </Container>
    );
}